export default __webpack_public_path__ + "static/media/2.54709377.jpg";